import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentBase } from 'src/app/core';

@Component({
  selector: 'app-terms-condition',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
})
export class TermsConditionsComponent extends ComponentBase {}
